// ── Thumbnail rail scroll arrows (horizontal): adds arrows to thumbnails so users can scroll through thumbnails on product detail pages ──
(function () {
  function initThumbnailArrows() {
    const rails = document.querySelectorAll('.slideshow-controls__thumbnails-container');

    rails.forEach((rail) => {
      if (rail.closest('.thumbnail-scroll-wrapper')) return;

      const parent = rail.parentElement;
      if (!parent) return;

      const wrapper = document.createElement('div');
      wrapper.className = 'thumbnail-scroll-wrapper';
      parent.insertBefore(wrapper, rail);

      // Left arrow
      const btnLeft = document.createElement('button');
      btnLeft.className = 'thumbnail-scroll-btn thumbnail-scroll-btn--left is-hidden';
      btnLeft.setAttribute('aria-label', 'Scroll thumbnails left');
      btnLeft.innerHTML = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <polyline points="15 18 9 12 15 6"></polyline></svg>`;

      // Right arrow
      const btnRight = document.createElement('button');
      btnRight.className = 'thumbnail-scroll-btn thumbnail-scroll-btn--right is-hidden';
      btnRight.setAttribute('aria-label', 'Scroll thumbnails right');
      btnRight.innerHTML = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <polyline points="9 18 15 12 9 6"></polyline></svg>`;

      wrapper.appendChild(btnLeft);
      wrapper.appendChild(rail);
      wrapper.appendChild(btnRight);

      const scrollAmount = 200;

      btnLeft.addEventListener('click', () => {
        rail.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
      });

      btnRight.addEventListener('click', () => {
        rail.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      });

      function updateButtons() {
        btnLeft.classList.toggle('is-hidden', rail.scrollLeft <= 0);
        btnRight.classList.toggle(
          'is-hidden',
          rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2
        );
      }

      rail.addEventListener('scroll', updateButtons, { passive: true });
      updateButtons();

      const images = rail.querySelectorAll('button');
      images.forEach((img) => img.addEventListener('load', updateButtons));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initThumbnailArrows);
  } else {
    initThumbnailArrows();
  }

  const observer = new MutationObserver(() => initThumbnailArrows());
  observer.observe(document.body, { childList: true, subtree: true });
})();
// end of thumbnail row arrow code

/* CC EDIT 2026 - Scroll to newsletter success message after submit */
document.addEventListener('DOMContentLoaded', function () {
  var params = new URLSearchParams(window.location.search);
  if (params.get('customer_posted') === 'true') {
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }
    window.scrollTo(0, 0); // cancel out the browser's native anchor jump

    var successMsg = document.querySelector('[id*="message-success"].email-signup__message');
    if (successMsg) {
      setTimeout(function () {
        successMsg.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 250);
    } else {
      console.warn('APS: success message element not found — selector may be stale.');
    }
  }
});

document.addEventListener('DOMContentLoaded', function () {
  // Grab current active currency from Shopify's global window object
  const activeCurrency = window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : null;

  // Only run if the active currency is NOT USD
  if (activeCurrency && activeCurrency !== 'USD') {
    function appendCurrencyCodes() {
      // Targets price elements across Horizon templates, product cards, and cart drawer
      const priceElements = document.querySelectorAll(
        '[class*="price"], .price-item, .cart-drawer__price, [data-price]'
      );

      priceElements.forEach((el) => {
        // Prevent duplicate tags
        if (!el.dataset.currencyAppended && el.textContent.trim().length > 0) {
          // Confirm it contains a price number and doesn't already have the currency code
          if (/\d/.test(el.textContent) && !el.textContent.includes(activeCurrency)) {
            el.insertAdjacentHTML(
              'beforeend',
              ` <span class="currency-tag" style="font-size: 1em; opacity: 0.85; font-family: inherit;">${activeCurrency}</span>`
            );
            el.dataset.currencyAppended = "true";
          }
        }
      });
    }

    // Run on initial page load
    appendCurrencyCodes();

    // Re-run dynamically when cart drawers open or variant prices switch
    const observer = new MutationObserver(appendCurrencyCodes);
    observer.observe(document.body, { childList: true, subtree: true });
  }
});